var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.altchaResponse)?_c('div',[_vm._v(" Verifying you are human... "),_c('b-spinner',{attrs:{"small":""}})],1):_c('div',[_vm._v(" Verified you are human "),_c('img',{attrs:{"src":require("@/assets/noun_check.svg"),"alt":"cleared"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }